import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker: PWA-Offline-Support + Cache
// Nur in Production registrieren (verhindert dev hot-reload Konflikte)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        // Bei neuer Version: User sanft auf Reload hinweisen
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.info('[SW] Neue Version verfügbar – beim nächsten Reload aktiv.');
            }
          });
        });
      })
      .catch((err) => console.warn('[SW] Registrierung fehlgeschlagen:', err));
  });
}

